import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";
import Tooltip from "../../../atoms/tooltip/Tooltip";
import { constructDate, destructDate } from "../../../../Helpers/DateHelper";

class DateInput extends React.Component {
  constructor(props) {
    super(props);
    this.monthRef = React.createRef();
    this.yearRef = React.createRef();
    this.state = {
      day: "",
      month: "",
      year: "",
      dateString: ""
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    const { dateString } = nextProps;

    if (dateString !== nextState.dateString) {
      const date = destructDate(dateString);
      if (date) {
        return { ...date, dateString };
      }
    }
    return null;
  }

  handleDayChange = event =>
    this.setState({ day: event.target.value }, () => this.updateDateValue());

  handleMonthChange = event =>
    this.setState({ month: event.target.value }, () => this.updateDateValue());

  handleYearChange = event =>
    this.setState({ year: event.target.value }, () => this.updateDateValue());

  updateDateValue() {
    const { day, month, year } = this.state;
    const { formikProps, setDobValidation, name } = this.props;

    const dateObject = constructDate(day, month, year);

    if (dateObject.invalid) {
      setDobValidation({ invalid: true, incomplete: false });
      formikProps.setFieldValue(name, "", true);
      formikProps.setFieldTouched(name, true, true);
    } else if (dateObject.incomplete) {
      setDobValidation({ invalid: false, incomplete: true });
      formikProps.setFieldValue(name, "", true);
      formikProps.setFieldTouched(name, true, true);
    } else {
      setDobValidation({ invalid: false, incomplete: false });
      formikProps.setFieldValue(name, dateObject.date.toISOString(), true);
      formikProps.setFieldTouched(name, false, true);
    }
  }

  render() {
    const {
      label,
      name,
      classes,
      wrapperClass,
      tooltip,
      required
    } = this.props;
    const { day, month, year } = this.state;

    return (
      <FormField classes={wrapperClass} name={name}>
        <Label text={label} id={name} required={required} />
        {tooltip && <Tooltip text={tooltip} />}
        <div>
          <Field
            value={day}
            className={classes}
            type="number"
            name="day"
            id="day"
            placeholder={window.Drupal.t("DD")}
            min="01"
            max="31"
            pattern="[0-9]*"
            onChange={this.handleDayChange}
            onBlur={() => this.updateDateValue()}
            onKeyUp={event => {
              if (
                event.target.value.length === 2 &&
                event.keyCode !== 8 &&
                event.keyCode !== 9 &&
                event.keyCode !== 16
              ) {
                if (this.monthRef.current) this.monthRef.current.focus();
              }
            }}
          />
          <Field
            value={month}
            className={classes}
            type="number"
            name="month"
            id="month"
            placeholder={window.Drupal.t("MM")}
            min="01"
            max="12"
            pattern="[0-9]*"
            onChange={this.handleMonthChange}
            innerRef={this.monthRef}
            onBlur={() => this.updateDateValue()}
            onKeyUp={event => {
              if (
                event.target.value.length === 2 &&
                event.keyCode !== 8 &&
                event.keyCode !== 9 &&
                event.keyCode !== 16
              ) {
                if (this.yearRef.current) this.yearRef.current.focus();
              }
            }}
          />
          <Field
            value={year}
            className={classes}
            type="number"
            name="year"
            id="year"
            innerRef={this.yearRef}
            placeholder={window.Drupal.t("YYYY")}
            min="1900"
            max={new Date().getFullYear()}
            pattern="[0-9]*"
            onChange={this.handleYearChange}
            onBlur={() => this.updateDateValue()}
            onKeyDown={event => {
              if (
                event.target.value.length === 4 &&
                event.keyCode !== 8 &&
                event.keyCode !== 9 &&
                event.keyCode !== 16
              ) {
                event.preventDefault();
              }
            }}
          />
        </div>
      </FormField>
    );
  }
}

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  formikProps: PropTypes.shape({
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func
  }).isRequired,
  setDobValidation: PropTypes.func.isRequired,
  dateString: PropTypes.string,
  classes: PropTypes.string,
  wrapperClass: PropTypes.string,
  tooltip: PropTypes.string,
  required: PropTypes.bool
};

DateInput.defaultProps = {
  classes: "form-item__textfield",
  wrapperClass: "form-item",
  dateString: "",
  tooltip: "",
  required: false
};

export default DateInput;
